
export class ClienteModel {
    [key: string]: string | number | boolean | null | undefined;
    
    id = ''; //10,

    tiene_datos = false;

    codigo?: number;

    nombre = ''; //Agromartinez SL,

    apellidos = ''; //,

    apellido_1 = ''; //,
    
    apellido_2 = ''; //,

    direccion? = ''; //C/ Alcalá 132,

    codigo_postal? = ''; //46003,

    provincia ?= ''; //Valencia,

    localidad? = ''; //Valencia,

    nif? = ''; //B-9958732,

    razon_social? = ''; //Agromartinez SL,

    telefono? = ''; //666111777,

    email? = ''; //hola@agromartinez.com

    cooperativa?: string;

    ropo?: string;

    id_usuario?: string | null;

    id_usuario_asignado?: string | null;

    id_usuario_asignado2?: string;

    acceso_plataforma?: boolean | number;

    tipo?: string;

    has_signature?: boolean;

    operador_explotacion?: string;

    gerente?: string;

    email_gerente?: string;

    telefono_gerente?: string;

    responsable_calidad?: string;

    email_responsable_calidad?: string;

    telefono_responsable_calidad?: string;

    regepa?: string;

    fecha_inicio?: string;

    fecha_fin?: string;

    id_cliente?: string;

    notas?: string;

    tipo_carnet?: string;
}